import { Injectable } from '@angular/core';
import { Mutation } from 'apollo-angular';
import gql from 'graphql-tag';

export interface GetRegistrationContextResult {
  getRegistrationContext: {
    token: string | null;
  };
}

export interface GetRegistrationContextVariables {
  input: {
    contextId: string;
    reCaptchaToken: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class GetRegistrationContextGraphQLService extends Mutation<
  GetRegistrationContextResult,
  GetRegistrationContextVariables
> {
  document = gql`
    mutation GetRegistrationContext($input: GetRegistrationContextInput!) {
      getRegistrationContext(input: $input) {
        token
      }
    }
  `;
}
